import {describe, test, vi, expect} from 'vitest'

vi.mock('../services/upgrade.js')

describe('upgrade command', () => {
  test('launches service with path', async () => {
    // PENDING
    expect(true).toBeTruthy()
  })
})
